import "./ContactApplication.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import BespokeShutterSolutions from "./sections/BespokeShutterSolutions";
import StoriesFromTheRoad from "./sections/StoriesFromTheRoad";
import ApplicationForm from "./sections/ApplicationForm";
import ContactDetails from "./sections/ContactDetails";
import Footer from "@/reusable_sections/Footer";
export default function ContactApplicationPage() {
  return <div>
      <MainNavigationHeader />
      <BespokeShutterSolutions />
      <StoriesFromTheRoad />
      <ApplicationForm />
      <ContactDetails />
      <Footer />
    </div>;
}